/**
 * 骨架屏 shimmer（深色下无白屏闪烁，design-spec §4 空态/骨架屏）。
 * 纯 CSS 流光扫过，无依赖；表格/卡片两套覆盖全站主要加载点。
 */
export function SkeletonTable({ rows = 8, cols = 6 }: { rows?: number; cols?: number }) {
  return (
    <div className="bcc-skeleton-table" role="status" aria-label="加载中">
      {Array.from({ length: rows }).map((_, r) => (
        <div className="bcc-skeleton-row" key={r} style={{ animationDelay: `${r * 40}ms` }}>
          {Array.from({ length: cols }).map((_, c) => (
            <span
              className="bcc-skeleton-block"
              key={c}
              style={{ width: `${72 + ((c * 37) % 26)}%`, animationDelay: `${(r * 40 + c * 60) % 500}ms` }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export function SkeletonCards({ count = 6 }: { count?: number }) {
  return (
    <div className="bcc-skeleton-cards">
      {Array.from({ length: count }).map((_, i) => (
        <div className="bcc-skeleton-card" key={i} style={{ animationDelay: `${i * 70}ms` }}>
          <span className="bcc-skeleton-icon" />
          <div className="bcc-skeleton-lines">
            <span className="bcc-skeleton-line w40" />
            <span className="bcc-skeleton-line w90" />
            <span className="bcc-skeleton-line w60" />
          </div>
        </div>
      ))}
    </div>
  );
}

/**
 * 表单骨架（设置页/配置弹层首屏）：按「label 条 + 控件条」模拟字段行，列数用 grid 跟随容器自适应。
 *
 * 为什么不用 `SkeletonTable`：表格骨架的行列节奏与表单完全不同，用在设置页上会让
 * 「正在读配置」看起来像「正在列数据」；也不用空态冒充加载（那会把"还没读到"读成"没有配置"）。
 */
export function SkeletonForm({ rows = 4, cols = 2 }: { rows?: number; cols?: number }) {
  return (
    <div className="bcc-skeleton-form" role="status" aria-label="加载中">
      {Array.from({ length: rows }).map((_, r) => (
        <div className="bcc-skeleton-form-row" key={r} style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
          {Array.from({ length: cols }).map((_, c) => (
            <div className="bcc-skeleton-form-field" key={c}>
              <span className="bcc-skeleton-block" style={{ width: 88, height: 13, animationDelay: `${(r * 40 + c * 60) % 500}ms` }} />
              <span className="bcc-skeleton-block" style={{ width: '100%', height: 32, animationDelay: `${(r * 40 + c * 60 + 80) % 500}ms` }} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
